import React from 'react';
import EmptyResult from '../EmptyResult';

export interface Props {
  isEmpty?: boolean;
}

export const ContentLoader: React.FC<Props> = ({ isEmpty, children }) => {
  if (isEmpty) {
    return <EmptyResult />;
  }

  return <>{children}</>;
};
ContentLoader.displayName = 'ContentLoader';

export default ContentLoader;
